import BlockFaqTop from './faqTop'

export default BlockFaqTop
